<div class="settings-wrapper">
    <mediabank-file-handler [(mediaFile)]="module.settings.content.image" fileType="11" 
        (callback)="setFile($event)"></mediabank-file-handler>
</div>